import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { OntologyTree } from '@/components/OntologyTree';
import { getOntologyRootNodeId } from '@/config/ontologyGraph';

export default function OntologyGraphPage() {
  const [searchParams] = useSearchParams();
  const diseaseId = searchParams.get('disease') ?? undefined;
  const rootNodeId = diseaseId ? getOntologyRootNodeId(diseaseId) : undefined;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <Helmet>
        <title>DISGENET: Ontology Explorer</title>
        <meta name="description" content="Interactive disease ontology tree explorer." />
      </Helmet>

      {/* Page header */}
      <header
        style={{
          padding: '16px 24px',
          borderBottom: '1px solid #e0e8f0',
          background: '#fff',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'baseline',
          gap: 12,
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 20,
            fontWeight: 700,
            color: '#1a2e44',
          }}
        >
          Ontology Explorer
        </h1>
        {diseaseId && (
          <span
            style={{
              fontSize: 13,
              color: '#6b7a8d',
              fontWeight: 400,
            }}
          >
            Root: <code style={{ fontSize: 12, color: '#4a90d9' }}>{diseaseId}</code>
          </span>
        )}
      </header>

      {/* Full-height tree — no box, no border */}
      <main style={{ flex: 1, minHeight: 0 }}>
        <OntologyTree rootNodeId={rootNodeId} />
      </main>
    </div>
  );
}
